import React from 'react';
import ReactDOM from 'react-dom';

import { Spin } from 'antd';
// 当前正在请求的数量
let requestCount = 0;
// 显示loading
export const showLoading = () => {
  if (requestCount === 0) { // 解决一个页面多个接口请求需要loading
    const dom = document.createElement('div');
    dom.setAttribute('id', 'loading');
    document.body.appendChild(dom);
    // document.body.style.cssText = 'overflow:hidden;';
    ReactDOM.render(<Spin tip="加载中" size="large" />, dom);
  }
  requestCount++;
};
// 隐藏loading
export const hideLoading = () => {
  requestCount--;
  if (requestCount === 0) {
    document.body.removeChild(document.getElementById('loading'));
    // document.body.style.cssText = 'overflow:"";';
  }
};